module.exports = __webpack_public_path__ + "img/ez-slot-category-casino-hover.2845234a.png";